import { Toast } from 'vant'

export default {
  /**
    * 工具名称: 操作错误提示
    * 参数说明：调用时传入内容msg
  **/
  requetServerError: function (msg) {
    Toast.fail(msg)
  },
  showSuccessMsg: function (msg) {
    Toast.success(msg)
  },
  getUrlParam (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var r = decodeURI(window.location.search).substr(1).match(reg)
    if (r != null) {
      return unescape(r[2])
    }
    return null
  },
  /**
   * 工具名称: 数字补零
   * 参数说明：调用时传入数字
   */
  formatBit (val) {
    val = +val
    return val > 9 ? val : '0' + val
  },
  /**
   * 工具名称: 媒体文件播放时长转换(将秒转换成00:00格式)
   * 参数说明：调用时传入秒
   */
  formatSecondToMinutes (time, fmt) {
    const thisObj = this
    let min = Math.floor(time % 3600)
    let val = ''
    switch (fmt) {
      case 'hh:mm:ss' :
        val = thisObj.formatBit(Math.floor(time / 3600)) + ':' + thisObj.formatBit(Math.floor(min / 60)) + ':' + thisObj.formatBit(time % 60)
        break
      case 'mm:ss' :
        val = thisObj.formatBit(Math.floor(min / 60)) + ':' + thisObj.formatBit(time % 60)
        break
      case 'S' :
        val = thisObj.formatBit(time % 60)
        break
    }
    return val
  }
}
